<template>
  <v-container class="d-flex align-center">
      <v-btn @click="$emit('click')"
        :disabled="disabled"
        class="backButton pa-0 pb-3" 
        text
        color="transparent">
        <img src="@/assets/Back.svg"/>
      </v-btn>
    </v-container>
</template>

<script>
  import { VBtn, VContainer } from 'vuetify/lib'
  export default {
    name: 'BackButton',
    components: {
      VBtn,
      VContainer
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
    }, 
  }
</script>